import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { useCancellationPlan } from 'src/context/billing';

import PlanUsageWarning from './PlanUsageWarning';
import ReviewAccountUsage from './ReviewAccountUsage';

const ActiveSolutionStepMap = {
  'show-plan-usage-warning': {
    title: 'It looks like you’re still using your plan!',
    description:
      'We won’t be able to cancel your plan while you’re still using it. Don’t worry, though, you have options. ',
    component: PlanUsageWarning,
  },
  'review-account-usage': {
    title: 'Review account use',
    description:
      'It looks like your Codekeeper account is currently being used for one or more software resilience product. While this is the case, we’re unable to cancel your plan.\n\nTo continue with cancelling your plan, please make sure the following cancellation requirements are met:',
    component: ReviewAccountUsage,
  },
};

const ActiveSolutionsDialog = () => {
  const {
    ui: { step, setInitialData },
  } = useCancellationPlan();

  const isOpen = Object.keys(ActiveSolutionStepMap).includes(step ?? '');

  const onOpenChange = (open: boolean) => {
    if (!open) setInitialData();
  };

  if (!step || !(step in ActiveSolutionStepMap)) return null;

  const {
    title,
    description,
    component: ActiveComponent,
  } = ActiveSolutionStepMap[step as keyof typeof ActiveSolutionStepMap];

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[784px] gap-6 grid-rows-[auto_1fr] min-h-0 max-h-[820px]">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription className="whitespace-pre-wrap">{description}</DialogDescription>
        </DialogHeader>
        <ActiveComponent />
      </DialogContent>
    </Dialog>
  );
};

export default ActiveSolutionsDialog;
